module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAACgBB6gBB6+GTHm5+jm5+i+GTHm5+i+GTHR09TR09S+GTHR09S+GTHm5+i+GTHm5+jm5+jR09Tm5+inqazBaU+gBB7R09Tm5+i+GTHwAVz1AAAAFHRSTlMA31BAQL9wgIBQ37+An8/PEJ+fr0sIehgAAADxSURBVHja7ZbLCsMgEEVr8zbvptXk/3+0YDUDGRe9RBdpPcvD5UACA94ONFJr2eCOdbShAR1HaoMEHUdbABcmFP/THvQTYcc/TTao84dA56fTukMdJ9ssGeCuESrdoIQcp1otFeCihmY3mD1uIbeQ81O4QQE5TrtZWshxRjcYIcfZdgAXNbTu+Nzk1HRwjJwGOeCuECq3nRJwnJoGNeAihnoa9JjjN+soABcxNNBggBy/EAJy/GYJwMUI3YU6hbjbjjrNpyTOh4QJqQCY0CsAvx5SAfif0NOi1HcuhVLIkG4t3VoKXezWgj1rgj20Aj793k7MJ2U4JONQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3ed.png
// module id = 821
// module chunks = 0